<template lang="pug">
.face-box(
  :style="boxStyle"
  :class="{ selected }"
  @pointerdown.stop="onPointerDown"
  @pointermove.stop.prevent="onPointerMove"
  @pointerup.stop="onPointerUp"
  @pointercancel.stop="onPointerUp"
)
  // optional: Resize-grips oder titel
  div.box-handle(v-if="selected") Move
</template>

<script>
export default {
  props: {
    face: { type: Object, required: true }, // expected { index, box: { x,y,w,h }, ... }
    scale: { type: Number, default: 1 },
    adminMode: { type: Boolean, default: false },
    selected: { type: Boolean, default: false }
  },
  data() {
    return {
      dragging: false,
      dragStartClientX: 0,
      dragStartClientY: 0
    };
  },
  computed: {
    boxStyle() {
      const b = this.face.box || this.face; // support direct or nested
      return {
        position: 'absolute',
        left: (b.x * this.scale) + 'px',
        top: (b.y * this.scale) + 'px',
        width: (b.w * this.scale) + 'px',
        height: (b.h * this.scale) + 'px',
        border: this.selected ? '2px solid #0af' : '2px solid rgba(255,0,0,0.8)',
        boxSizing: 'border-box',
        background: this.selected ? 'rgba(0,150,255,0.06)' : 'transparent',
        cursor: this.adminMode ? 'move' : 'pointer',
        zIndex: 100
      };
    }
  },
  methods: {
    onPointerDown(e) {
      if (!this.adminMode) {
        // emit select to parent (no moving)
        this.$emit('select', this.face);
        return;
      }
      // start dragging
      this.dragging = true;
      this.dragStartClientX = e.clientX;
      this.dragStartClientY = e.clientY;
      // capture pointer
      e.target.setPointerCapture?.(e.pointerId);
      // mark selected
      this.$emit('select', this.face);
    },
    onPointerMove(e) {
      if (!this.dragging) return;
      // delta in screen px -> convert to image px by dividing by scale
      const dx = (e.clientX - this.dragStartClientX) / this.scale;
      const dy = (e.clientY - this.dragStartClientY) / this.scale;
      this.dragStartClientX = e.clientX;
      this.dragStartClientY = e.clientY;

      // mutate local face box coords (Vue reactivity will update position)
      if (this.face.box) {
        this.face.box.x += dx;
        this.face.box.y += dy;
      } else {
        this.face.x += dx;
        this.face.y += dy;
      }
      // no emit each move to avoid spamming; emit onPointerUp when done
    },
    onPointerUp(e) {
      if (!this.dragging) return;
      this.dragging = false;
      e.target.releasePointerCapture?.(e.pointerId);

      // emit final face for persistence
      this.$emit('submit', this.face);
    }
  }
};
</script>

<style scoped lang="less">
.face-box {
  /* nothing fancy, position done inline */
}
.box-handle {
  position: absolute;
  right: 2px;
  top: 2px;
  font-size: 10px;
  background: rgba(255,255,255,0.6);
  padding: 2px 4px;
  border-radius: 3px;
  pointer-events: none;
}
</style>
